import { Component, AfterViewInit, OnInit, ChangeDetectorRef, Renderer } from '@angular/core';

import {Title } from '@angular/platform-browser';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';
import { MdSnackBar } from '@angular/material';

import { StorageService } from '../services/storage.service';
import { RestService } from '../services/rest.service';
import { PrintService } from 'app/print/print.service';

import 'rxjs/add/operator/toPromise';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'export',
  providers: [StorageService, RestService, PrintService],
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss']
})
export class ExportComponent implements AfterViewInit, OnInit {

  parcelCode: string;
  scannedValue: string = null;
  parcelCount: number = 0;

  storages: any[] = [];
  private storage: any = null;
  loadedParcel: boolean = false;
  status: string = null;
  reference: string = null;
  tracking: any;
  orders: any[];
  order: any;

  private mainContainer: any = null;
  mainContainerName: string;
  loadedMainContainer: boolean = false;  
  exportCountry: string = null;
  lineHaul: any;
  relabel: string = null;

  filterTitle: string;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _restService: RestService,
    private _printService: PrintService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _dialogService: TdDialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService,
    private _snackBarService: MdSnackBar,
    public renderer: Renderer) {
  }

  ngOnInit(): void {
    this._titleService.setTitle('Export');
    this.load();
    this._route.url.subscribe((url: any) => {
      this.exportCountry = (url.length > 1 ? url[1].path : '');
    });

  }


  loadFilter(filterTitle: string) {
    this.filterTitle = filterTitle;
  }

  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    this.media.broadcast();
    // force a new change detection cycle since change detections
    // have finished when `ngAfterViewInit` is executed
    this._changeDetectorRef.detectChanges();
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('export.list');
      this.loadFilter('All export');    
    } catch (error) {

    } finally {
      this._loadingService.resolve('export.list');
    }
  }

  async loadMainContainer(mainContainerName: string): Promise<void> {
    try {
      //validate container: it must exist
      this.mainContainer = await this._storageService.getContainer(mainContainerName).toPromise();
      if (this.mainContainer.containerStatus == 'OPEN') {
        // Check that the line_haul.workflow matches the export country
        let addInfoItem: any = this.mainContainer.addInfo.find(element => element.keyValue == 'line_haul');
        // get lineHaul by name
        this.lineHaul = await this._storageService.getLineHaulByNameAndWorkflow(addInfoItem.textValue, 'export'+ this.exportCountry).toPromise();
        if (!this.lineHaul) {
          this._dialogService.openAlert({ message: 'Line haul is not found'});
          this.loadedMainContainer = false;
        } else {     
          this.mainContainerName = this.mainContainer.name;
          this.loadedMainContainer = true;
          this.storages = await this._storageService.getContainerNameParcels(mainContainerName).toPromise();
          this.parcelCount = this.storages.reduce((total, storage) => total + storage.itemCount, 0);
        }
      } else {
        this._dialogService.openAlert({ message: 'Container in wrong status!: ' + this.mainContainer.containerStatus });
        this.loadedMainContainer = false;
      }
    } catch (error) {
      //container does not exist
      this.loadedMainContainer = false;
    } finally {
    }
  }

  isMainContainerLoaded() {
    return this.loadedMainContainer;
  }

  async loadValue(value: string): Promise<void> {
    
      if (this.mainContainer.containerStatus == 'OPEN') {
        try {
          // clear loaded values
          this.clearForm();
          // load the new parcel
          await this.loadParcel(value);
          this.scannedValue = null;
          if (this.loadedParcel) {
            this.parcelCount++;
          }
        } catch (error) {
            this.status = 'none';
            this.loadedParcel = false;
        }
      } else {
        this._dialogService.openAlert({ message: 'Container in wrong status!: ' + this.mainContainer.containerStatus });
        this.loadedMainContainer = false;
        this.loadedParcel = false;
        this.scannedValue = null;
      }
  }

  async loadParcel(value: string): Promise<void> {
    try {
      await this.getParcel(value); 

      if (!this.storage) { // parcel not stored
        if (this.relabel == 'LIMIT_EXCEEDED') {
          this.status = 'LimitExceeded';
          this.loadedParcel = false;
          this.reference = null;
          this.parcelCode = value;
        } else if (this.relabel == 'DUPLICATED') {
          this.status = 'Duplicated';
          this.loadedParcel = false;
          this.reference = null;
          this.parcelCode = value;
        } else {
          this.status = 'NoData';
          this.loadedParcel = false;
          this.reference = null;
          this.parcelCode = value;

          // Error sound when No data!
          let audio = new Audio();
          audio.src = "../assets/error.mp3";
          audio.load();
          audio.play();
        

        }
      } else { 
        // RETURNED VALUES: SCAN_SENT, SEND_SCAN_FAILED, TRACKINGNUMBER (XXXX), RELABEL_FAILED, NO_RELABEL
        if (this.relabel == 'SEND_SCAN_FAILED') {
          this.status = 'SendScanFailed';
          this.parcelCode = value;
          this.reference = null;
          this.loadedParcel = false;
        } else if (this.relabel == 'SCAN_SENT' || this.relabel == 'RELABEL') {
          this.status = 'ForRelabel';
          this.parcelCode = value;
          this.reference = this.storage.reference;
          this.loadedParcel = true;
        } else if (this.relabel == 'RELABEL_FAILED') {
          this.status = 'RelabelFailed';
          this.parcelCode = value;
          this.reference = null;
          this.loadedParcel = false;
        } else if (this.relabel == 'NO_RELABEL') {
          this.status = 'OK';
          this.parcelCode = value;
          this.reference = this.storage.reference;
          this.loadedParcel = true;
        } else if (this.relabel == 'PRINT') { // Tracking Number
          this.status = 'PrintLabel';
          this.parcelCode = value;
          this.reference = this.storage.reference;
          this.loadedParcel = true;
        }
      }
      
    } catch (error) {
      this.status = 'none';
      this.loadedParcel = false;
    } finally {
    }
  }

  async getStorageStatus(trackingNumber: string): Promise<any> {
    return await this._storageService.getStorageStatus(trackingNumber).toPromise();
  }

 /*
  CASE 1	Scan 1. No relabel needed. Match container line_haul =>	Show OK. Store
  CASE 2	Scan 1. No data. Does not matter if line_haul matches or not =>	Show NO DATA. Do not store.
  CASE 3	Scan 1. Limit exceeded. Does not matter if line_haul matches or not	=> Show LIMIT EXCEEDED. Do not store.
  CASE 4	Scan 1. No relabel needed. Container line_haul does NOT match. =>	Show Container not allowed. Do not store
  CASE 5	Scan 1. Relabel needed. Does not matter if line_haul matches or not. =>	Show RELABEL. Do not store.
  CASE 6	Scan 1. Relabel needed. First scan fails.	=> Show SCAN FAILED! Do not store.
  CASE 7	Scan 2. Relabel needed. New label matches container line_haul => Show PRINT LABEL. Store.
  CASE 8	Scan 2. Relabel needed. New label does NOT match container line_haul.	=> Show PRINT LABEL. Pop-up for new container. Sotre to new.
  CASE 9	Scan 2. Relabel needed. Second scan fails. =>	Show RELABEL FAILED! Do not store.
  */
  async getParcel(reference: string): Promise<void> {
    try{
      // checkRelabeling =>
      // get tracking
      // get trackingItemInfo.routingInformation
      // get order
      // checks if relabeling needed

      // POSSIBLE RETURNED VALUES in relabelResponse.result
      // SCAN_SENT: relabeling needed, first scan OK.
      // SEND_SCAN_FAILED: relabeling needed, first scan failed.
      // TRACKINGNUMBER (XXXX): relabeling needed, second scan OK (new label and tracking generated). Get and print label
      // RELABEL_FAILED: relabeling needed, second scan failed.
      // NO_RELABEL: relabeling not needed.
      // LIMIT_EXCEEDED: the customs value of the order surpasses configured limit

      //let relabelResponse : any = await this._restService.checkRelabeling(reference).toPromise();


      // EXPORT CH CASE
      if (this.exportCountry == 'CH') {
        
        let trackingCH = await this._restService.getTracking(reference).toPromise();
        let trackingItemInfoCH = await this._restService.getTrackingItemInfo(trackingCH.id).toPromise();
        this.relabel = 'NO_RELABEL';

        if (!trackingItemInfoCH.routingInformation || trackingItemInfoCH.routingInformation == this.lineHaul.name) {

          let orders = await this._restService.getOrders(trackingCH.reference, trackingCH.projectId).toPromise();
          let order: any = null;
          // get first order not attached to manifest
          for (let element of orders) { 
            if (element.mawb == null) {
              order = element;
              break;
            }
          }
          
          let storage = {
            itemCount: 1,
            containerName: this.mainContainerName,
            reference: trackingCH.reference, 
            workflowStatus: 'TAXATION',
            storeUser: null,
            storeDate: new Date(),
            businessKey: order.businessKey, 
            projectId: trackingCH.projectId 
          }
          this.storage = storage;
          this._storageService.createStorage(storage).toPromise();
          // create event (to be able to track where the parcel was initially stored)
          let restEvent = {
            eventDate: new Date(),
            source: 'INTERNAL',
            reference: trackingCH.reference,
            trackingNumber: reference,
            status: 'ARRIVED_HUB',
            description: "storage service : store to container (" + this.mainContainerName + ")",
            internal: true
          }
          this._restService.createEvent(restEvent).toPromise();
          return;
        } else {
          // CASE 4)
          this._dialogService.openAlert({ message: 'Container Line haul (' + this.lineHaul.name + ') does not match parcel routing information (' + trackingItemInfoCH.routingInformation + ')' });
          return;
        }

      }


      let storageStatus: any = await this._storageService.getStorageStatus(reference).toPromise();
      if (storageStatus) {
        this.relabel = storageStatus.storageStatus;
      }

      
      if (this.relabel != null) {

        let storage = {
          itemCount: 1,
          containerName: this.mainContainerName,
          reference: storageStatus.reference,
          workflowStatus: 'TAXATION',
          storeUser: null,
          storeDate: new Date(),
          businessKey: storageStatus.orderBusinessKey,
          projectId: storageStatus.projectId
        }

        if (this.relabel == 'LIMIT_EXCEEDED' || this.relabel == 'DUPLICATED') {
          // CASE 3
          console.log(this.relabel + '!');
          this.storage = null;
          // create event (to be able to track that the parcel arrived)
          let restEvent = {
            eventDate: new Date(),
            source: 'INTERNAL',
            reference: storageStatus.reference,
            trackingNumber: reference,
            status: 'ARRIVED_HUB',
            description: this.relabel,
            internal: true
          }
          this._restService.createEvent(restEvent).toPromise();
          return;
        }

      
        if (this.relabel == 'RELABEL') {
          // CASE 5)
          // CASE 6)
          storage.containerName = null;
          this.storage = storage;
          // triggers
          // send received scan 
          // update status from RELABLE to PRINT 
          this._storageService.calculateStorageStatus(storageStatus.orderBusinessKey, reference).toPromise();
          // create send received scan event
          let restScanEvent = {
            eventDate: new Date(),
            source: 'INTERNAL',
            reference: storageStatus.reference,
            trackingNumber: reference,
            status: 'SEND_RECEIVED_SCAN',
            remark: "Parcel service received scan",
            internal: true,
            description: storageStatus.orderBusinessKey // to later process events, we don't know the client
          }
          this._restService.createEvent(restScanEvent).toPromise();
        } else if (this.relabel == 'NO_RELABEL') {      
          if (!storageStatus.routingInformation || storageStatus.routingInformation == this.lineHaul.name) {
            // CASE 1)
            let restScanEvent = {
              eventDate: null,
              source: 'INTERNAL',
              reference: storageStatus.reference,
              trackingNumber: reference,
              status: 'SEND_RECEIVED_SCAN',
              remark: "Parcel service received scan",
              internal: true,
              description: storageStatus.orderBusinessKey // to later process events, we don't know the client
            }
            this._restService.createEvent(restScanEvent).toPromise();

            this.storage = storage;
            // update sorter status mark as processed 
            this._storageService.calculateStorageStatus(storageStatus.orderBusinessKey, reference).toPromise();
            this._storageService.createStorage(storage).toPromise();
            // create event (to be able to track where the parcel was initially stored)
            let restEvent = {
              eventDate: new Date(),
              source: 'INTERNAL',
              reference: storageStatus.reference,
              trackingNumber: reference,
              status: 'ARRIVED_HUB',
              description: "storage service : store to container (" + this.mainContainerName + ")",
              internal: true
            }
            this._restService.createEvent(restEvent).toPromise();
          } else {
            // CASE 4)
            this._dialogService.openAlert({ message: 'Container Line haul (' + this.lineHaul.name + ') does not match parcel routing information (' + storageStatus.routingInformation + ')' });
          }

        } else if (this.relabel === 'PRINT') {
          // TRIGGER THE GENERATION OF THE NEW LABEL HERE
          try {
            const relabelingResponse = await this._restService
              .doRelabeling(storageStatus.orderBusinessKey, reference)
              .toPromise();
            const relabelingResult = relabelingResponse.relabelingResults[0];
            // to avoid NO DATA response
            this.storage = storage;
            // update sorter status mark as processed 
            this._storageService
              .calculateStorageStatus(storageStatus.orderBusinessKey, reference)
              .toPromise();
            // get and print label
            await this._restService.getLabel(relabelingResult.trackingNumber).toPromise();
            await this.sleep(1000);
            await this._printService.print('labelPrinter', relabelingResult.trackingNumber).toPromise();
            // check that package with new label is being loaded to the correct container       
            if (!relabelingResult.routingInformation || relabelingResult.routingInformation !== this.lineHaul.name) {
              // CASE 8
              this._dialogService.openPrompt({
                message: "Enter a container that matches the line haul " + relabelingResult.routingInformation
              }).afterClosed().subscribe(data => {
                storage.containerName = data;
                this.storage = storage;
                this._storageService.createStorage(storage).toPromise();
                // create event…
                const restEvent = {
                  eventDate: new Date(),
                  source: 'INTERNAL',
                  reference: relabelingResponse.reference,
                  trackingNumber: relabelingResult.trackingNumber,
                  status: 'ARRIVED_HUB',
                  description: "storage service : store to container (" + storage.containerName + ")",
                  internal: true
                };
                this._restService.createEvent(restEvent).toPromise();
                try {
                  this._storageService.resolveException(storageStatus.trackingNumber, storageStatus.reference).toPromise();
                } catch (e) {
                  console.log('Cannot resolve exception!');
                }
              });
            } else {
              // CASE 7
              storage.containerName = this.mainContainerName;
              this.storage = storage;
              this._storageService.calculateStorageStatus(storageStatus.orderBusinessKey, reference).toPromise();
              this._storageService.createStorage(storage).toPromise();
              // create event…
              const restEvent = {
                eventDate: new Date(),
                source: 'INTERNAL',
                reference: relabelingResponse.reference,
                trackingNumber: relabelingResult.trackingNumber,
                status: 'ARRIVED_HUB',
                description: "storage service : store to container (" + storage.containerName + ")",
                internal: true
              };
              this._restService.createEvent(restEvent).toPromise();
              try {
                this._storageService.resolveException(storageStatus.trackingNumber, storageStatus.reference).toPromise();
              } catch (e) {
                console.log('Cannot resolve exception!');
              }
            }
          } catch (error) {
            console.error('doRelabeling failed:', error);
            this.status = 'RelabelFailed';
            this._dialogService.openAlert({
              message: 'Print-label request failed. Please retry.'
            });
            return;
          }
        }
      } else {
        // CASE 2)
        console.log('No data!');
        this.storage = null;

        // create event (to be able to track that the parcel arrived)
        let restEvent = {
          eventDate: new Date(),
          source: 'INTERNAL',
          reference: reference,
          trackingNumber: reference,
          status: 'ARRIVED_HUB',
          description: "no data",
          internal: true
        }
        this._restService.createEvent(restEvent).toPromise();

        // create storage exception NOT_FOUND with status PENDING
        let exception = {
          reference : null,
          code : reference, // tracking number
          exceptionDate : new Date(),
          exceptionType : 'NOT_FOUND',
          exceptionStatus : 'PENDING',
          containerName : null
        }
        this._storageService.sendToException(exception).toPromise();

      }
        
    } catch (error) {
        console.error('getParcel failed:', error);
        console.log('Cannot get parcel!');
        this.storage = null;

        // CASE 2)
        console.log('No data!');

        // create event (to be able to track that the parcel arrived)
        let restEvent = {
          eventDate: new Date(),
          source: 'INTERNAL',
          reference: reference,
          trackingNumber: reference,
          status: 'ARRIVED_HUB',
          description: "no data",
          internal: true
        }
        this._restService.createEvent(restEvent).toPromise();

        // create storage exception NOT_FOUND with status PENDING
        let exception = {
          reference : null,
          code : reference, // tracking number
          exceptionDate : new Date(),
          exceptionType : 'NOT_FOUND',
          exceptionStatus : 'PENDING',
          containerName : null
        }
        this._storageService.sendToException(exception).toPromise();

    } finally {
    }
  }

  sleep(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }


  getStatus() {
    return this.status;
  }

  keytab(event, from: string){ 
    let innerText: string = 'Scan parcel'; // move cursor to Scan parcel at the end
    if (from == 'mainContainerName') {
      this.loadMainContainer(this.mainContainerName);
    } else if (from == 'scannedValue') {
      this.loadValue(this.scannedValue);
    }


    let path = event.composedPath();
    let element = path[5]; // naviagte to md-card-content

    let child;

      for (let j = 0; j < element.children.length; j++) {
        if (element.children[j].innerText == innerText) { // navigate to md-input-container with the given text
          child = element.children[j].children[0].children[0].children[0].children[0]; // navigate to input area where value is entered
        }
      }

    if(child == null)  // check if its null
        return;
    else
      child.focus();   // focus if not null
        return;
  }

  isParcelLoaded() {
    return this.loadedParcel;
  }

  closeContainer() {
    this._closeContainer();
  }

  async _closeContainer() {
    this.mainContainer.containerStatus = 'CLOSED';
    this.mainContainer.addInfo = [];
      if (this.lineHaul.name) {
        let item: any = {}; item.keyValue = 'line_haul'; item.textValue = this.lineHaul.name; this.mainContainer.addInfo.push(item);}
    await this._storageService.updateContainer(this.mainContainer, true).toPromise();
    this._snackBarService.open('Container closed', 'OK');
  }

  goBack(): void {
    this.clearForm();
    this.mainContainer = null;
    this.mainContainerName = null;
    this.loadedMainContainer = false;
    this.lineHaul = null; 
    this._router.navigate(['/stockup/export/'+this.exportCountry]);
  }

  clearForm() {
    this.parcelCode = '';
    this.storage = null;
    this.status = null;
    this.reference = null;
    this.relabel = null;
    //this.load();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/export/export.component.ts